import React, { Component } from 'react';
import { connect } from 'react-redux';
import $ from 'jquery';
import { PARTNERS_STORY_DETAIL_API_URL } from "../../store/constants/urls";
import '../newsEvent/newsEvent.css';
import '../newsEventsDetail/newsEventsDetail.css';
import PartnerStoryPartial from "./PartnerStoryPartial";
import Loading from '../common/Loading';
import { scrollTop } from '../../utils/helpers';

class PartnerStory extends Component {

    state = {
        partnerStory: null,
        nextStoryId: null,
        additionalStories: [],
        isLoadingMore: false,
        loadingMoreNewsCompleted: false,
        lastScrollPos: 0,
        url: ''
    }


    componentDidMount() {
        scrollTop();
        let id = this.props.match.params.id;
        let url = PARTNERS_STORY_DETAIL_API_URL;
        url = url.replace(/{id}/g, id);
        fetch(url)
            .then(data => data.json())
            .then(res => {
                if (res.data) {
                    this.setState({
                        partnerStory: res.data,
                        nextStoryId: res.data.nextPartnerStory.id
                    })
                }
            });
        window.addEventListener('scroll', this.onScroll)
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (this.state.url !== nextState.url || this.state.lastScrollPos != nextState.lastScrollPos) {
            return false;
        }
        return true;
    }

    onScroll = () => {

        let nearBottom = $(window).scrollTop() + $(window).height() > $(document).height() - 500;
        let scrollDown = this.state.lastScrollPos < $(window).scrollTop();
        this.setState({
            lastScrollPos: $(window).scrollTop()
        });

        if (scrollDown && nearBottom && !this.state.isLoadingMore && !this.state.loadingMoreNewsCompleted) {
            let nextStoryId = this.state.nextStoryId;
            this.loadMoreStories(nextStoryId);
        }
    }

    loadMoreStories = (id) => {
        if (id) {
            this.setState({ isLoadingMore: true });
            let url = PARTNERS_STORY_DETAIL_API_URL;
            url = url.replace(/{id}/g, id);
            fetch(url)
                .then(data => data.json())
                .then(res => {
                    if (res.data) {
                        let stories = this.state.additionalStories.concat(res.data);
                        this.setState({
                            additionalStories: stories,
                            nextStoryId: res.data.nextPartnerStory.id,
                            isLoadingMore: false
                        });
                    } else {
                        this.setState({ isLoadingMore: false, loadingMoreNewsCompleted: true });
                    }
                });
        } else {
            this.setState({ loadingMoreNewsCompleted: true });
        }
    }

    render() {
        let data = this.state.partnerStory;
        let { isEnglish } = this.props;
        return (
            <div className="container">
                <div className="row">
                    <div className="col-xs-12">
                        {data && <PartnerStoryPartial isEnglish={isEnglish} data={data} isAdditionalStory={false} />}
                        <hr />
                        {this.state.additionalStories.map(data => <PartnerStoryPartial isEnglish={isEnglish} data={data} isAdditionalStory={true} />)}
                        {this.state.isLoadingMore && !this.state.loadingMoreNewsCompleted && <Loading />}
                    </div>
                </div>
            </div>
        );
    }

}

const mapStateToProps = state => {
    return {
        isEnglish: state.changeLanguage.isEnglish
    }
}

export default connect(mapStateToProps)(PartnerStory);